import { render, staticRenderFns } from "./module_form.html?vue&type=template&id=39aa942b&"
import script from "./EditModule.vue?vue&type=script&lang=js&"
export * from "./EditModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports